import Vue from 'vue'
import configs from '@/config'
import store from '@/vuex/store'

let resource = null

const actions = {
  deleteCountingUnique: {
    method: 'DELETE',
    url: `${configs.liveProxyUrl}/api/live/counting/unique`,
  },
  deleteCountingUniqueNewKafka: {
    method: 'DELETE',
    url: `${configs.liveProxyUrl}/api/${configs.LiveProxyRootPath}/counting/unique`,
  },
}

const initResource = () => {
  resource = Vue.resource('', {}, actions)
}

const deleteCountingUnique = async (payload) => {
  if (store.getters['liveStatsV2/canSubmitNewLiveProxy']) {
    return resource.deleteCountingUniqueNewKafka({}, payload)
  }
  return resource.deleteCountingUnique({}, payload)
}

export default {
  initResource,
  deleteCountingUnique,
}
